import styled from 'styled-components';

export const StldInput = styled.div`
    position: relative;

    & label {
        color: #333333;
        position: absolute;
        left: 1rem;
        top: .5rem;
        transition: .2s;
    }

    & label.focused {
        top: -13px;
        font-size: .8rem;
        background-color: #fff;
        padding: .25rem .25rem 0;
        transition: .2s;
    }

    & label.focused_index {
        z-index: 9999;
    }

    & input {
        padding: .7rem .5rem;
        border-radius: .25rem;
        border: solid 1px #D2D2D2;
        width: -webkit-fill-available;
    }

    & select {
        padding: .8rem .5rem;
        border-radius: .25rem;
        border: solid 1px #D2D2D2;
        width: -webkit-fill-available;
    }

    & textarea {
        padding: .7rem .5rem;
        border-radius: .25rem;
        border: solid 1px #D2D2D2;
        width: -webkit-fill-available;
    }

    @media only screen and (max-width: 1400px) {

              label.select-custom-tipo {
                display: block !important;
                color: #333333 !important;
                position: absolute;
                left: 0.5rem !important;
                top: 0rem !important;
                transition: .2s !important;
                padding: .25rem !important;
            }

            label.focused.select-custom-tipo {
                display: none !important;
            }

    }


    label.focused.select-custom-tipo {
      display: none !important;
    }


 .clear-btn {
    position: absolute;
    top: 12px;
    right: 5px;

 }

 .select-clear {
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
 }



`